import type { Prototype } from "../prototype-types";

export const jeanYangPrototypes: Prototype[] = [
  {
    id: "jy-budget-history-modal-deprecation",
    name: "Budget history modal deprecation",
    path: "/jy/budget-history-modal-deprecation",
    description:
      "Variant: settings history flyout with multi-option Show filter (budget, status, growth, audience, store types, and more)",
    owner: "Jean Yang",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-11",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/cbff3a9dbea5d52e22bebd706f003e726e863ae589d6daa734b3e95cc911747b.png",
    creationTool: "cursor",
    project: "Ads Manager",
  },
];
